import { useEffect, useState } from "react";
import styles from "./employProfileManagement.module.css";
import TabBar from "components/tabBar/TabBar";
import ProfileForm from "components/profileForm/costumerProfileForm";
import { useNavigate } from "react-router-dom";
import { getParentKids } from "services/get-parents-kids";
import { IoIosArrowForward } from "react-icons/io";
import { setProfileArchived } from "services/profileManegement/set-profile-archived";
import EmployKidManagment from "./employKidManagment";
import { checkSession } from "services/userLogin/check-session";
import { getProfileInfo } from "services/profileManegement/get-profile-info";
import { KidsData } from "modules/profile";
import { setProfileDearchived } from "services/profileManegement/set-profile-dearchived";
import SuccessPopup from "components/successPopup/successPopup";

interface ProfileManagementProps {
    id: number;
    name: string;
    isArchived: boolean;
    onBack: () => void;
}

export default function EmployProfileManagement({ id, name, isArchived, onBack }: ProfileManagementProps) {
    const navigate = useNavigate();
    const [kidsData, setKidsData] = useState<KidsData[]>([]);
    const tabs = [
        { id: "data", label: "Erziehungsberechtigte" },
        { id: "kids", label: `Kinder (${kidsData.length || 0})` },
    ];
    const [activeTab, setActiveTab] = useState<string>(tabs[0].id);
    const [initialValues, setInitialValues] = useState({
        first_name: "",
        last_name: "",
        country: "",
        phone: "",
        zip: "",
        city: "",
        street: "",
        status: "",
        faculty: "",
        account_holder: "",
        iban: "",
        bic: "",
        emergencyContacts: [{ name: '', phone: '' }],
    });
    const [currentValues, setCurrentValues] = useState(initialValues);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);

    const fetchData = async () => {
        try {
            const kidsDataRes = await getParentKids(id ?? null);
            setKidsData(kidsDataRes?.kids || []);
        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
        }
    };
    const handelArchivProfile = async () => {
        try {
            await setProfileArchived(id ?? null);
            setIsSuccessPopupOpen(true)
        } catch (error) {
            console.error("Fehler bei der Archivierung von Daten:", error);
        }
    };
    const handelDearchivProfile = async () => {
        try {
            await setProfileDearchived(id ?? null);
            setIsSuccessPopupOpen(true)
        } catch (error) {
            console.error("Fehler bei der Dearchivierung von Daten:", error);
        }
    };

    const verifySession = async () => {
        try {
            const sessionData = await checkSession();
            if (sessionData.session_active) {
                const profileData = await getProfileInfo(id ?? null);
                if (profileData.success) {
                    setInitialValues(profileData.profile);
                    setCurrentValues(profileData.profile);
                }
            } else {
                navigate('/reservierungsportal', { replace: true });
            }
        } catch (error) {
            console.error("Error during session check:", error);
        }
    };

    useEffect(() => {
        verifySession();
        fetchData();
    }, []);

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
    };

    return (
        <div className={styles.container}>
            <div className={styles.navigation}>
                <p onClick={onBack}>Nutzerverwaltung</p> <IoIosArrowForward /> {name}
            </div>

            <TabBar tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />

            <div className={styles.tabContent}>
                {activeTab === "data" && (
                    <ProfileForm
                        profile_id={id}
                        initialValues={currentValues}
                        buttonOptions={[

                            {
                                label: "Abbrechen",
                                onClick: () => onBack(),
                            }, {
                                label: isArchived ? "Wiederherstellen" : "Archivieren",
                                onClick: isArchived ? () => handelDearchivProfile() : () => handelArchivProfile(),
                            },
                            {
                                label: "Speichern",

                            },
                        ]}
                        onSubmitSuccess={() => {
                            fetchData();
                            onBack();
                        }}
                    />

                )}
                {activeTab === "kids" && <EmployKidManagment kidsData={kidsData}
                    onBack={() => { onBack(); fetchData(); }} />}

            </div>
            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                onBack();
                setIsSuccessPopupOpen(false);
            }} />
        </div>
    );
}
